module.exports = __webpack_public_path__ + "img/workout6.bc743001.jpg";